(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-mobile-sticky-buy"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = () => {
    document.querySelectorAll('[data-bf-mobile-buybar]').forEach((bar) => {
      if (bar.dataset.initialized) return;
      bar.dataset.initialized = '1';
      const trigger = bar.querySelector('[data-bf-buy-trigger]');
      if (trigger) trigger.addEventListener('click', () => {
        const button = document.querySelector('.product-form__add-button:not([disabled])');
        if (button) button.click();
      });
      const update = () => bar.classList.toggle('is-visible', window.innerWidth <= 740 && window.scrollY > 260);
      addEventListener('scroll', update, { passive: true });
      addEventListener('resize', update);
      update();
    });
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init, { once: true }) : init();
})();
  } catch(e) { console.error(e); }
})();

})();
